import "./styles.css";

const ActivePulseBullet = () => {
  return <span className='blob green'></span>;
};

export const DeactivePulseBullet = () => {
  return <span className='blob red'></span>;
};

export default ActivePulseBullet;
